/* eslint-disable react/jsx-indent */
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Input, Card, CardBody, Col, CardHeader, ModalFooter,
  Row, Button, Modal, ModalHeader, ModalBody,
  Label, FormGroup } from 'reactstrap'
import Select from '../../../components/Template/Input/Select'
import MaskedInput from '../../../components/Template/Input/MaskedInput'
import { getRegs, notifyDtLiberacaoFaturamentoAlterada, PROD_COORDENADOR_PF_FIELDS, oikosGet } from '../../../utils/fc'
import { addDaysYmd as addDaysLimite, criarSolicitacaoDataLimite, toYmd as toYmdLimite } from '../../../utils/alteracaoDataLimite'
import { prodRecIds, splitProdRecIds } from '../../../utils/prodRecExtra'
import { mapRiscoTpRows, riscoTpOptionForId } from '../../../utils/prodRiscoTp'
import DatePicker from 'react-datepicker'
import PqGridView from '../../Modal/PqGridView'
import moment from 'moment'
import {MaterialReactTable} from 'material-react-table'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Edit from '@material-ui/icons/Edit'
import api_powerapps from '../../../services/powerapps/index'
import { Typography, Autocomplete, TextField } from '@mui/material'
import TimelineStatusProduto from '../../TimelineStatusProduto/TimelineStatusProduto'
import { getProjectProducts } from '../../../store/ducks/technicalDep'
import oikosApi from '../../../services/oikos'
import qs from 'qs';
import { notifySuccess, notifyError } from '../../../utils/notify'
import { create } from 'apisauce'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import CalendarLocale from '@fullcalendar/core/locales/pt-br'
import GridProductsCalendar from '../../GridProductsCalendar/GridProductsCalendar'
import Legenda from '../../Legenda/Legenda'
import DashboardProdutos from '../../../pages/TechnicalDep/Products/DashboardProdutos'
import '../../../assets/css/custom-fc-event.css'

let tooltipTimeout;

const check_prods_api = create({
  baseURL: "https://oikos.ecoss.is/oikos/_webhook_checkprods.php",
})

check_prods_api.addResponseTransform(response => {
  if (!response.ok) throw response
})

const labelStyle = {
  fontSize: '0.75rem',
  color: '#adb5bd',
  lineHeight: '1.5',
  marginTop: 16,
}

const sticky_scrollbar_container = {
  position: 'fixed', /* Fix the container at the bottom of the viewport */
  bottom: 0,       /* Stick to the bottom */
  left: 0,         /* Stick to the left edge */
  width: '100%',     /* Full width of the viewport */
  zIndex: 1000,   /* Ensure it is above other content if necessary */
  backgroundColor: 'white', /* Optional: set background color */
  boxShadow: '0 -1px 5px rgba(0, 0, 0, 0.1)', /* Optional: add some shadow for visibility */
}

const sticky_scrollbar_content = {
  overflowX: 'auto', /* Enable horizontal scrolling */
  whiteSpace: 'nowrap', /* Prevent wrapping of the table contents */
}

class Prod extends Component {
  constructor(props) {
    super(props)
    this._expandFetches = new Set()
    this.state = {
      data: false,
      dataIsLoading: false,
      calendarDateOption: 'Data prevista',
      isTable: true,
      isGrid: false,
      isCalendar: false,
      isDashboard: false,
      pqGridViewIsOpen: false,
      dropdownOpenRow: null,
      specificProduct: {},
      specificProductIsLoading: false,
      editingDate: null, // { prod_id, field, value(YYYY-MM-DD) }
      solicitacaoDataLimite: null,

      refreshTimeline: 0,
      editProjectTeamDialogIsOpen: false,
      editProjectTeamPeople: [],

      addProductModalIsOpen: false,
      addProductData: {},

      addActivityModalIsOpen: false,
      addActivityData: {},

      addDocumentModalIsOpen: false,
      addMailModalIsOpen: false,

      getDocumentsIsLoading: false,
      documents: [],

      documentsProducts: [],

      emailData: {},

      selTpStatus: false,

      productsOfProject: {},
      productDetails: {},
      loadingRows: [],

      /** Eventos de pagamento (rec) da rubrica do projeto — para associar a prod.rec_id na grelha */
      recList: [],

      /** Edição REC na grelha: duplo clique, como datas — { prod_id, options, selected } */
      editingRec: null,

      /** Edição da flag prodFatFlag_id: { prod_id, selected } — 0=Não, 1=Sim */
      editingFatFlag: null,

      /** Edição inline de prod_risco (0–6): { prod_id, selected } — selected null = limpar */
      editingRisco: null,

      /** Catálogo riscoTp (prod_risco → abrev/nome) */
      riscoTpOptions: [],

      /** Se o usuário marcou flag=1 sem rec, grava a flag junto no próximo save do evento */
      pendingFatFlagOn: null,
    }
  }

  prodFatFlagOptions = () => ([
    { prodFatFlag_id: 0, prodFatFlag_nome: 'Não' },
    { prodFatFlag_id: 1, prodFatFlag_nome: 'Sim' },
  ])

  fatFlagRequiredRecMsg = 'Com faturamento associado, é obrigatório informar um ou mais eventos de faturamento.'

  isProdFatFlagOn = (row) => Number(row?.prodFatFlag_id) === 1

  hasProdRec = (row) => prodRecIds(row).length > 0

  recOptionsForProduct = (data) => {
    const open = this.recEmAbertoList()
    const ids = prodRecIds(data)
    const options = [...open]
    ids.forEach((id) => {
      if (options.some((r) => Number(r.rec_id) === Number(id))) return
      const found = (this.state.recList || []).find((r) => Number(r.rec_id) === Number(id))
      options.push(found || { rec_id: id, rec_ep: '' })
    })
    return options
  }

  /** Opção sintética «nenhum REC» para o Autocomplete */
  recNoneOption = () => ({ __none: true, rec_id: null, rec_ep: '' })

  /** rec_risco > 0: evento ainda não quitado. */
  isRecEmAberto = (rec) => Number(rec?.rec_risco) > 0

  recEmAbertoList = (list = this.state.recList) => (
    (list || []).filter((rec) => this.isRecEmAberto(rec))
  )

  /** rec_desc = prazo contratual (ex.: "30 dias" ou número de dias). */
  formatRecPrazoPgto = (val) => {
    if (val == null || val === '') return null
    const s = String(val).trim()
    if (!s) return null
    if (/^\d+$/.test(s)) return `${s} dias`
    return s
  }

  getRecPgtoDisplay = (row) => {
    const rid = row?.rec_id
    if (rid == null || rid === '') return null
    let prazo = row.rec_prazoPgto_asso
    let regra = row.recTp_nome_asso
    const rec = (this.state.recList || []).find((r) => String(r.rec_id) === String(rid))
    if (rec) {
      if (!prazo && rec.rec_desc != null && rec.rec_desc !== '') prazo = rec.rec_desc
      if (!regra && rec.recTp_nome) regra = rec.recTp_nome
    }
    const prazoFmt = this.formatRecPrazoPgto(prazo)
    const regraFmt = regra != null && String(regra).trim() !== '' ? String(regra).trim() : null
    if (!prazoFmt && !regraFmt) return null
    if (prazoFmt && regraFmt) return `${prazoFmt} · ${regraFmt}`
    return prazoFmt || regraFmt
  }

  startRecEdit = (prod_id) => {
    if (!this.canEditSensitiveDates()) return
    if (!this.props.orcRubr_id) {
      notifyError('Projeto sem rubrica de orçamento (orcRubr_id).')
      this.setState({ pendingFatFlagOn: null })
      return
    }
    const row = (this.state.data || []).find((p) => Number(p.prod_id) === Number(prod_id))
    const allRecs = this.state.recList || []
    const openRecs = this.recEmAbertoList(allRecs)
    const ids = prodRecIds(row)
    if (allRecs.length === 0 && ids.length === 0) {
      notifyError('Não há eventos de pagamento nesta rubrica.')
      this.setState({ pendingFatFlagOn: null })
      return
    }
    if (openRecs.length === 0 && ids.length === 0) {
      notifyError('Não há eventos de pagamento em aberto nesta rubrica.')
      this.setState({ pendingFatFlagOn: null })
      return
    }
    const options = [...openRecs]
    ids.forEach((id) => {
      if (options.some((r) => Number(r.rec_id) === Number(id))) return
      const found = allRecs.find((r) => Number(r.rec_id) === Number(id))
      options.push(found || { rec_id: id, rec_ep: '' })
    })
    const selected = options.filter((r) => ids.includes(Number(r.rec_id)))
    this.setState({ editingRec: { prod_id, options, selected } })
  }

  cancelRecEdit = () => {
    this.setState({ editingRec: null, pendingFatFlagOn: null })
  }

  commitRecEdit = async () => {
    const ed = this.state.editingRec
    if (!ed) return
    const selected = Array.isArray(ed.selected) ? ed.selected : (ed.selected ? [ed.selected] : [])
    const ids = selected
      .filter((s) => s && !s.__none && s.rec_id != null && s.rec_id !== '')
      .map((s) => Number(s.rec_id))
    const row = (this.state.data || []).find((p) => Number(p.prod_id) === Number(ed.prod_id))
    const pendingFlag = this.state.pendingFatFlagOn != null
      && Number(this.state.pendingFatFlagOn) === Number(ed.prod_id)
    const next = splitProdRecIds(ids, row && row.rec_id)
    const nextIds = prodRecIds(next)
    if (JSON.stringify(prodRecIds(row)) === JSON.stringify(nextIds) && !pendingFlag) {
      this.setState({ editingRec: null })
      return
    }
    if (pendingFlag && next.rec_id == null) {
      notifyError(this.fatFlagRequiredRecMsg)
      this.setState({ editingRec: null, pendingFatFlagOn: null })
      return
    }
    await this.saveProdRec(ed.prod_id, ids)
  }

  startFatFlagEdit = (prod_id, current) => {
    if (!this.canEditSensitiveDates()) return
    this.setState({
      editingFatFlag: {
        prod_id,
        selected: Number(current) === 1 ? 1 : 0,
      },
    })
  }

  cancelFatFlagEdit = () => {
    this.setState({ editingFatFlag: null })
  }

  commitFatFlagEdit = async () => {
    const ed = this.state.editingFatFlag
    if (!ed) return
    const next = Number(ed.selected) === 1 ? 1 : 0
    const row = (this.state.data || []).find((p) => Number(p.prod_id) === Number(ed.prod_id))
    const orig = this.isProdFatFlagOn(row) ? 1 : 0
    if (next === orig) {
      this.setState({ editingFatFlag: null })
      return
    }
    await this.saveProdFatFlag(ed.prod_id, next)
  }

  prodRiscoOptions = () => (
    this.state.riscoTpOptions?.length
      ? this.state.riscoTpOptions
      : mapRiscoTpRows([])
  )

  /** Opções 0–6 + «nenhum» — mesmo padrão de Autocomplete inline do evento de pagamento. */
  prodRiscoEditOptions = () => ([
    { __none: true, value: null, label: '—', abrev: '—' },
    ...this.prodRiscoOptions(),
  ])

  startRiscoEdit = (prod_id, current) => {
    if (!this.canEditSensitiveDates()) return
    const cur = this.normalizeProdRisco(current)
    this.setState({
      editingRisco: {
        prod_id,
        selected: cur,
      },
    })
  }

  cancelRiscoEdit = () => {
    this.setState({ editingRisco: null })
  }

  commitRiscoEdit = async () => {
    const ed = this.state.editingRisco
    if (!ed) return
    const next = this.normalizeProdRisco(ed.selected)
    const row = (this.state.data || []).find((p) => Number(p.prod_id) === Number(ed.prod_id))
    const orig = this.normalizeProdRisco(row?.prod_risco)
    if (next === orig) {
      this.setState({ editingRisco: null })
      return
    }
    await this.saveProdRisco(ed.prod_id, next)
  }

  saveProdRisco = async (prod_id, riscoValue) => {
    if (!this.canEditSensitiveDates()) return
    const prod_risco = this.normalizeProdRisco(riscoValue)
    try {
      await oikosApi.post('/', {
        action: 'update',
        table: 'prod',
        data: {
          prod_id,
          prod_risco,
        },
      })
      notifySuccess('Risco atualizado.')
      this.setState({ editingRisco: null })
      this.preloading()
    } catch (e) {
      const apiMsg =
        e?.response?.data?.message ||
        e?.response?.data?.error ||
        e?.message ||
        ''
      notifyError(
        `Erro ao atualizar o risco${apiMsg ? `: ${String(apiMsg)}` : '.'}`
      )
      console.log('saveProdRisco', e?.response?.data || e)
    }
  }

  isPermAdmin = () => Number(this.props.auth?.user?.perm_id) === 1

  /** Datas normais + descrição: dev, diretor ou perm_id = 1 */
  canEditDates = () => {
    if (this.isPermAdmin()) return true
    const cargo = String(this.props.userCargo || '').toLowerCase()
    return cargo.includes('desenvolvedor') || cargo.includes('diretor')
  }

  /** Datas sensíveis + vínculo REC: dev, diretor, gerente financeiro ou perm_id = 1 */
  canEditSensitiveDates = () => {
    if (this.isPermAdmin()) return true
    const cargo = String(this.props.userCargo || '').toLowerCase()
    return (
      cargo.includes('desenvolvedor') ||
      cargo.includes('diretor') ||
      cargo.includes('gerente financeiro')
    )
  }

  startDateEdit = (prod_id, field, value) => {
    const sensitive = ['prod_dtEntrega', 'prod_dtAprov', 'prod_dtAutFat']
    if (sensitive.includes(field)) {
      if (!this.canEditSensitiveDates()) return
      const labels = {
        prod_dtEntrega: 'Entrega',
        prod_dtAprov: 'Aprovação Produto',
        prod_dtAutFat: 'Autorização faturamento',
      }
      const label = labels[field] || 'campo'
      const ok = window.confirm(`Deseja realmente editar "${label}"?`)
      if (!ok) return
    } else {
      if (!this.canEditDates()) return
    }
    if (field === 'prod_dtLimAprov') {
      const row = (this.state.data || []).find((item) => Number(item.prod_id) === Number(prod_id))
      this.setState({
        editingDate: null,
        solicitacaoDataLimite: {
          prod: row || { prod_id },
          novaData: value || '',
          dataAnterior: value || null,
          motivo: '',
          saving: false,
        },
      })
      return
    }
    this.setState({ editingDate: { prod_id, field, value: value || '' } })
  }

  cancelDateEdit = () => {
    this.setState({ editingDate: null })
  }

  saveDateEdit = async () => {
    if (this._savingDate) return
    const ed = this.state.editingDate
    if (!ed || !ed.prod_id || !ed.field) return
    this._savingDate = true
    const fieldLabel = (field) => {
      switch (field) {
        case 'prod_desc': return 'Descrição'
        case 'prod_dtContrato': return 'Contratual'
        case 'prod_dtInterna': return 'Interna'
        case 'prod_dtEntrega': return 'Entrega'
        case 'prod_dtAprov': return 'Aprovação Produto'
        case 'prod_dtAutFat': return 'Autorização faturamento'
        case 'prod_dtLimAprov': return 'Limite para faturamento'
        default: return 'Campo'
      }
    }

    try {
      const isDateField = (field) => (
        field === 'prod_dtContrato' ||
        field === 'prod_dtInterna' ||
        field === 'prod_dtLimAprov' ||
        field === 'prod_dtAutFat' ||
        field === 'prod_dtEntrega' ||
        field === 'prod_dtAprov'
      )

      const valueToApi = (field, v) => {
        if (isDateField(field)) return v ? v : null // DATE não aceita ''
        return v === undefined ? null : v // texto aceita ''
      }

      const addDaysYmd = (ymd, days) => {
        if (!ymd) return null
        const m = moment(ymd, 'YYYY-MM-DD', true)
        if (!m.isValid()) return null
        return m.add(days, 'days').format('YYYY-MM-DD')
      }

      const updateProduct = {
        action: 'update',
        table: 'prod',
        data: {
          prod_id: ed.prod_id,
          [ed.field]: valueToApi(ed.field, ed.value),
        },
      }

            const row = (this.state.data || []).find((p) => Number(p.prod_id) === Number(ed.prod_id))

      if (ed.field === 'prod_dtLimAprov') {
        const nova = valueToApi(ed.field, ed.value)
        const anterior = toYmdLimite(row?.prod_dtLimAprov)
        if (!nova) {
          notifyError('Informe a nova data limite de faturamento.')
          this.setState({ editingDate: null })
          return
        }
        if (nova === anterior) {
          this.setState({ editingDate: null })
          return
        }
        this.setState({
          editingDate: null,
          solicitacaoDataLimite: {
            prod: row || { prod_id: ed.prod_id },
            novaData: nova,
            dataAnterior: anterior,
            motivo: '',
            saving: false,
          },
        })
        return
      }

      // Contratual grava na hora, com a interna (−4). O limite (+25) só entra se for aprovado.
      let limiteSugerido = null
      if (ed.field === 'prod_dtContrato') {
        if (ed.value) {
          updateProduct.data.prod_dtInterna = addDaysYmd(ed.value, -4)
          limiteSugerido = addDaysYmd(ed.value, 25)
        } else {
          updateProduct.data.prod_dtInterna = null
        }
      }      const toYmd = (v) => {
        if (!v) return null
        const m = moment(v)
        return m.isValid() ? m.format('YYYY-MM-DD') : null
      }

      await oikosApi.post('/', updateProduct)
      notifySuccess(`${fieldLabel(ed.field)} atualizado com sucesso.`)

      if (ed.field === 'prod_dtContrato' && limiteSugerido) {
        const anteriorLim = toYmdLimite(row?.prod_dtLimAprov)
        if (limiteSugerido !== anteriorLim) {
          this.setState({
            solicitacaoDataLimite: {
              prod: row || { prod_id: ed.prod_id },
              novaData: limiteSugerido,
              dataAnterior: anteriorLim,
              motivo: '',
              saving: false,
            },
          })
          notifySuccess('A nova data limite de faturamento depende de aprovação.')
        }
      }

      if (ed.field === 'prod_dtAutFat') {
        const previousDate = toYmd(row?.prod_dtAutFat)
        const newDate = toYmd(valueToApi(ed.field, ed.value))
        if (previousDate !== newDate) {
          try {
            const user = this.props.auth?.user
            await notifyDtLiberacaoFaturamentoAlterada({
              product: row || { prod_id: ed.prod_id },
              previousDate,
              newDate,
              usuario: user?.displayName || user?.mail || '—',
            })
          } catch (mailErr) {
            console.log('Falha ao notificar alteração da data de liberação de faturamento.', mailErr)
          }
        }
      }

      this.setState({ editingDate: null })
      this.preloading()
    } catch (e) {
      const apiMsg =
        e?.response?.data?.message ||
        e?.response?.data?.error ||
        e?.message ||
        ''
      notifyError(
        `Erro ao atualizar ${ed && ed.field ? fieldLabel(ed.field).toLowerCase() : 'campo'}${apiMsg ? `: ${String(apiMsg)}` : '.'}`
      )
      console.log('Não foi possível atualizar a data.', e?.response?.data || e)
    } finally {
      this._savingDate = false
    }
  }

  /** Mesma regra que datas sensíveis: vínculo produto–REC é informação financeira. */
  saveProdRec = async (prod_id, recIds) => {
    if (!this.canEditSensitiveDates()) return
    const row = (this.state.data || []).find((p) => Number(p.prod_id) === Number(prod_id))
    const split = splitProdRecIds(recIds, row && row.rec_id)
    const pendingFlag = this.state.pendingFatFlagOn != null
      && Number(this.state.pendingFatFlagOn) === Number(prod_id)
    const flagOn = pendingFlag || this.isProdFatFlagOn(row)
    if (flagOn && split.rec_id == null) {
      notifyError(this.fatFlagRequiredRecMsg)
      return
    }
    const data = {
      prod_id,
      rec_id: split.rec_id,
      prod_recExtra: split.prod_recExtra,
    }
    if (pendingFlag && split.rec_id != null) {
      data.prodFatFlag_id = 1
    }
    try {
      await oikosApi.post('/', {
        action: 'update',
        table: 'prod',
        data,
      })
      notifySuccess(pendingFlag && split.rec_id != null
        ? 'Faturamento associado e evento atualizados.'
        : 'Evento de pagamento atualizado.')
      this.setState({ editingRec: null, pendingFatFlagOn: null })
      this.preloading()
    } catch (e) {
      const apiMsg =
        e?.response?.data?.message ||
        e?.response?.data?.error ||
        e?.message ||
        ''
      notifyError(
        `Erro ao associar evento de pagamento${apiMsg ? `: ${String(apiMsg)}` : '.'}`
      )
      console.log('saveProdRec', e?.response?.data || e)
    }
  }

  saveProdFatFlag = async (prod_id, flagValue) => {
    if (!this.canEditSensitiveDates()) return
    const prodFatFlag_id = Number(flagValue) === 1 ? 1 : 0
    const row = (this.state.data || []).find((p) => Number(p.prod_id) === Number(prod_id))
    if (prodFatFlag_id === 1 && !this.hasProdRec(row)) {
      notifyError(this.fatFlagRequiredRecMsg)
      this.setState({ editingFatFlag: null, pendingFatFlagOn: prod_id })
      this.startRecEdit(prod_id, row?.rec_id, row?.rec_ep_asso)
      return
    }
    try {
      await oikosApi.post('/', {
        action: 'update',
        table: 'prod',
        data: {
          prod_id,
          prodFatFlag_id,
        },
      })
      notifySuccess('Flag de faturamento atualizada.')
      this.setState({ editingFatFlag: null, pendingFatFlagOn: null })
      this.preloading()
    } catch (e) {
      const apiMsg =
        e?.response?.data?.message ||
        e?.response?.data?.error ||
        e?.message ||
        ''
      notifyError(
        `Erro ao atualizar a flag de faturamento${apiMsg ? `: ${String(apiMsg)}` : '.'}`
      )
      console.log('saveProdFatFlag', e?.response?.data || e)
    }
  }

  handleSubmitProduct = async () => {
    const { addProductData } = this.state
    const prodFatFlag_id = Number(addProductData?.prodFatFlag_id) === 1 ? 1 : 0
    const rec_id = addProductData?.rec_id == null || addProductData.rec_id === ''
      ? null
      : Number(addProductData.rec_id)
    const prod_risco = this.normalizeProdRisco(addProductData?.prod_risco)
    const prod_riscoDet = addProductData?.prod_riscoDet != null && String(addProductData.prod_riscoDet).trim() !== ''
      ? String(addProductData.prod_riscoDet).trim()
      : null
    if (prodFatFlag_id === 1 && rec_id == null) {
      notifyError(this.fatFlagRequiredRecMsg)
      return
    }
    if (!addProductData.prod_id) {
      // Será necessário criar um novo registro
      try {
        const insertProduct = {
          action: 'insert',
          table: 'prod',
          data: {
            proj_id: addProductData.proj_id,
            prod_num: addProductData?.prod_num || undefined,
            prod_desc: addProductData?.prod_desc,
            prod_avalEP: addProductData?.prod_avalEP || undefined,
            prod_aprovEP: addProductData?.prod_aprovEP || undefined,
            prod_obsEP: addProductData?.prod_obsEP,
            prod_responsavel: addProductData?.prod_responsavel,
            prod_vlr: Number(addProductData?.prod_vlr),
            prod_dtContrato: addProductData.prod_dtContrato ? moment(addProductData.prod_dtContrato).format('YYYY-MM-DD') : undefined,
            prod_dtInterna: addProductData.prod_dtInterna ? moment(addProductData.prod_dtInterna).format('YYYY-MM-DD') : undefined,
            prod_dtEntrega: addProductData.prod_dtEntrega ? moment(addProductData.prod_dtEntrega).format('YYYY-MM-DD') : undefined,
            prod_dtAprov: addProductData.prod_dtAprov ? moment(addProductData.prod_dtAprov).format('YYYY-MM-DD') : undefined,
            prod_dtLimAprov: addProductData.prod_dtLimAprov ? moment(addProductData.prod_dtLimAprov).format('YYYY-MM-DD') : undefined,
            prodStatusTp_id: addProductData?.prodStatusTp_id,
            prod_formato: addProductData?.prod_formato,
            prodFatFlag_id,
            rec_id: rec_id == null ? undefined : rec_id,
            prod_recExtra: addProductData.prod_recExtra || null,
            prod_risco: prod_risco == null ? undefined : prod_risco,
            prod_riscoDet: prod_riscoDet == null ? undefined : prod_riscoDet,
          },
        }
        console.log('insertProduct ', insertProduct)
        const productCreated = await oikosApi.post('/', insertProduct)
        notifySuccess('Produto cadastrado com sucesso.')
        this.props.getProjectProducts(addProductData.proj_id)
        this.preloading()
      } catch (e) {
        notifyError('Erro ao cadastrar o produto');
        console.log('Não foi possível cadastrar o produto.', e)
      }
    } else {
      // O produto está sendo editado. Basta usar a rota de atualização
      try {
        const origLim = toYmdLimite(addProductData.prod_dtLimAprovOriginal)
        const origContr = toYmdLimite(addProductData.prod_dtContratoOriginal)
        const formLim = addProductData.prod_dtLimAprov ? moment(addProductData.prod_dtLimAprov).format('YYYY-MM-DD') : null
        const formContr = addProductData.prod_dtContrato ? moment(addProductData.prod_dtContrato).format('YYYY-MM-DD') : null
        let novaLimPendente = null
        const updateProduct = {
          action: 'update',
          table: 'prod',
          data: {
            prod_id: addProductData.prod_id,
            proj_id: addProductData.proj_id,
            prod_num: addProductData?.prod_num || undefined,
            prod_desc: addProductData?.prod_desc,
            prod_avalEP: addProductData?.prod_avalEP || undefined,
            prod_aprovEP: addProductData?.prod_aprovEP || undefined,
            prod_obsEP: addProductData?.prod_obsEP,
            prod_responsavel: addProductData?.prod_responsavel,
            prod_vlr: Number(addProductData?.prod_vlr),
            prod_dtContrato: formContr || undefined,
            prod_dtInterna: addProductData.prod_dtInterna ? moment(addProductData.prod_dtInterna).format('YYYY-MM-DD') : undefined,
            prod_dtEntrega: addProductData.prod_dtEntrega ? moment(addProductData.prod_dtEntrega).format('YYYY-MM-DD') : undefined,
            prod_dtAprov: addProductData.prod_dtAprov ? moment(addProductData.prod_dtAprov).format('YYYY-MM-DD') : undefined,
            prod_dtLimAprov: formLim || undefined,
            prodStatusTp_id: addProductData?.prodStatusTp_id,
            prod_formato: addProductData?.prod_formato,
            prodFatFlag_id,
            rec_id,
            prod_recExtra: addProductData.prod_recExtra || null,
            prod_risco,
            prod_riscoDet,
          },
        }
        if (formContr !== origContr && formContr) {
          updateProduct.data.prod_dtInterna = addDaysLimite(formContr, -4)
        }
        if (formLim !== origLim) {
          delete updateProduct.data.prod_dtLimAprov
          if (!formLim) {
            notifyError('Informe a nova data limite de faturamento.')
          } else {
            novaLimPendente = formLim
          }
        } else if (formContr !== origContr && formContr) {
          const sugerida = addDaysLimite(formContr, 25)
          if (sugerida && sugerida !== origLim) {
            novaLimPendente = sugerida
            delete updateProduct.data.prod_dtLimAprov
          }
        }
        console.log('updateProduct ', updateProduct)
        const productUpdated = await oikosApi.post('/', updateProduct)
        notifySuccess('Produto atualizado com sucesso.')
        if (novaLimPendente) {
          this.setState({
            solicitacaoDataLimite: {
              prod: { ...addProductData, rec_id },
              novaData: novaLimPendente,
              dataAnterior: origLim,
              motivo: '',
              saving: false,
            },
          })
          notifySuccess('A nova data limite de faturamento depende de aprovação.')
        }
        this.props.getProjectProducts(addProductData.proj_id)
        this.preloading()
      } catch (e) {
        notifyError('Erro ao atualizar o produto');
        console.log('Não foi possível cadastrar o produto.', e)
      }
    }
    this.setState({ addProductModalIsOpen: false, addProductData: {} })
  }

  static dictStatusTextNumber = {
    'Não iniciado': 8,
          'Em Elaboração': 6,
          'Entregue ao EP': 4,
          'Entregue à Gestão': 3,
          'A entregar p/ Cliente':2,
          'Entregue ao Cliente':5,
          'Aprovado pelo Cliente':7,
          'Faturamento Autorizado':9,
          'Em correção':1,

  }
  componentDidMount() {

    console.log(this.props)

    this.credentialsOikos()
    this.preloading()
  }

  preloading = async() => {
    await fetch(`https://oikos.ecoss.is/oikos/_webhook_checkprods.php?proj_id=${this.props.proj_id}`)

    this.setState({dataIsLoading: true })
    console.log("props Prod ", this.props)
    const prodFields = {
      prod_dtEntrega: 'prod_dtEntrega',
      prod_dtAprov: 'prod_dtAprov',
      prod_dtLimAprov: 'prod_dtLimAprov',
      "(SELECT COUNT(*) FROM prod p WHERE p.prod_ativo = 1 AND p.prod_dtLimAprov >= DATE_FORMAT(CURDATE() - INTERVAL 1 MONTH, '%Y-%m-01') AND p.prod_dtLimAprov <  DATE_FORMAT(CURDATE(), '%Y-%m-01') AND NOT EXISTS (SELECT 1 FROM prodStatusAlt psa WHERE psa.prod_id = p.prod_id AND psa.prodStatusTp_id = 7 AND COALESCE(psa.prodStatusAlt_ativo, 1) = 1))": "prodNaoAprovadosMesAnterior",
      "(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria ASC LIMIT 1)": "prodEntregueAoClienteData",
      "(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusTp_id = 7 AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria ASC LIMIT 1)": "prodAprovacaoData",
      "(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusTp_id = 8 AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria ASC LIMIT 1)": "prodAutFatData",
      "(SELECT pst.prodStatusTp_nome FROM prodStatusTp pst WHERE pst.prodStatusTp_id = (SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY psa.prodStatusAlt_dtCria DESC LIMIT 1) AND pst.prodStatusTp_ativo = 1 LIMIT 1)": "prodStatusActual_nome",
      "(SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)": "prodStatusActual_id",
      "(SELECT psa.prodStatusAlt_obs FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)": "prodStatusAlt_obs",
      "(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)": "prodStatusAlt_data",
      "(SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1 OFFSET 1)": "prodStatusPenultimo_id",
      "(SELECT proj_nome FROM proj WHERE proj.proj_id = prod.proj_id)": "proj_nome",
      "(SELECT pfCoord.pf_emailProf FROM prodStatusAlt psa, projEquipe pe, pf pfCoord WHERE psa.prod_id = prod.prod_id AND pe.proj_id = prod.proj_id AND pfCoord.pf_id = pe.pf_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_id = (SELECT psa2.prodStatusAlt_id FROM prodStatusAlt psa2 WHERE psa2.prod_id = prod.prod_id AND psa2.prodStatusTp_id = 6 ORDER BY psa2.prodStatusAlt_data DESC, psa2.prodStatusAlt_id DESC LIMIT 1) AND pe.projAtuacao_id = 8 AND psa.prodStatusAlt_data >= pe.projEquipe_ini AND (pe.projEquipe_fim IS NULL OR psa.prodStatusAlt_data <= pe.projEquipe_fim) LIMIT 1)": "prod_responsavel_email",
      "(SELECT pfCoord.pf_nomeExibicao FROM prodStatusAlt psa, projEquipe pe, pf pfCoord WHERE psa.prod_id = prod.prod_id AND pe.proj_id = prod.proj_id AND pfCoord.pf_id = pe.pf_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_id = (SELECT psa2.prodStatusAlt_id FROM prodStatusAlt psa2 WHERE psa2.prod_id = prod.prod_id AND psa2.prodStatusTp_id = 6 ORDER BY psa2.prodStatusAlt_data DESC, psa2.prodStatusAlt_id DESC LIMIT 1) AND pe.projAtuacao_id = 8 AND psa.prodStatusAlt_data >= pe.projEquipe_ini AND (pe.projEquipe_fim IS NULL OR psa.prodStatusAlt_data <= pe.projEquipe_fim) LIMIT 1)": "prod_responsavelNome",
      '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 AND projEquipe.projEquipe_fim IS NULL ORDER BY projEquipe_dtCria DESC LIMIT 1))' : 'prod_responsavelNomeAtual',
      '(SELECT pf_emailProf FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 AND projEquipe.projEquipe_fim IS NULL ORDER BY projEquipe_dtCria DESC LIMIT 1))' : 'prod_responsavel_email_atual',
      ...PROD_COORDENADOR_PF_FIELDS,
      "(SELECT prodStatusTp_nome FROM prodStatusTp WHERE prodStatusTp.prodStatusTp_id = prod.prodStatusTp_id)": "prodStatusTp_nome",
      "(SELECT proj.projSituacao_id FROM proj WHERE proj.proj_id = prod.proj_id)": "projSituacao_id",
      "(SELECT proj.proj_nome FROM proj WHERE proj.proj_id = prod.proj_id)": "proj_nome",
      "(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 AND psa.prodStatusTp_id = 6 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)": "prodEntregueAoClienteData",
      "(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 AND psa.prodStatusTp_id = 7 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)": "prodAprovacaoData",
      //'(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 ORDER BY projEquipe_dtCria DESC LIMIT 1))' : 'prod_responsavelNome',
      //'(SELECT prodStatusTp_id FROM prodStatusAlt WHERE prodStatusAlt.prod_id = prod.prod_id AND prodStatusAlt.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)' : 'prodStatusActual_id',
      //"(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria ASC LIMIT 1)": "prodEntregueAoClienteData",
      //"(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusTp_id = 7 AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria ASC LIMIT 1)": "prodAprovacaoData",
      "(SELECT rec_ep FROM rec WHERE rec.rec_id = prod.rec_id AND rec.rec_ativo = 1 LIMIT 1)": "rec_ep_asso",
      "(SELECT rec_desc FROM rec WHERE rec.rec_id = prod.rec_id AND rec.rec_ativo = 1 LIMIT 1)": "rec_prazoPgto_asso",
      "(SELECT recTp.recTp_nome FROM recTp INNER JOIN rec ON rec.recTp_id = recTp.recTp_id WHERE rec.rec_id = prod.rec_id AND rec.rec_ativo = 1 LIMIT 1)": "recTp_nome_asso",
    }
    const orcRubrId = this.props.orcRubr_id
    const recFields = orcRubrId
      ? {
          "(SELECT recTp_nome FROM recTp WHERE recTp.recTp_id = rec.recTp_id LIMIT 1)": "recTp_nome",
        }
      : null
    const [dataRaw, recRaw, riscoTpRaw] = await Promise.all([
      getRegs('prod', { proj_id: this.props.proj_id }, prodFields),
      orcRubrId ? getRegs('rec', { orcRubr_id: orcRubrId }, recFields) : Promise.resolve([]),
      getRegs('riscoTp', {}),
    ])
    const data = Array.isArray(dataRaw) ? dataRaw : []
    const recList = Array.isArray(recRaw) ? recRaw : []
    const riscoTpOptions = mapRiscoTpRows(Array.isArray(riscoTpRaw) ? riscoTpRaw : [])
    console.log("lista do Prod ", data)

    // Buscar datas de entrega diretamente da tabela prodStatusAlt (mesma fonte da timeline)
    await Promise.all(data.map(async (product) => {
      try {
        const res = await oikosApi.get(`/?${qs.stringify({
          action: 'get',
          table: 'prodStatusAlt',
          data: {
            prod_id: product.prod_id,
            prodStatusTp_id: 6,
          },
        })}`);
        if (res.data && res.data.length > 0) {
          product.prodEntregueAoClienteData = res.data[0].prodStatusAlt_data;
        }
      } catch (e) {
        console.log('Erro ao buscar data de entrega para prod_id:', product.prod_id, e);
      }
    }));

    this.setState({ data, recList, riscoTpOptions, dataIsLoading: false })
  }

  renderPmtFat = (fat) => {
    let fat_badge
    let fat_label
    switch (fat) {
      case 0:
        fat_badge = `badge badge-warning` // Pendente
        fat_label = `Não` // Pendente
        break
      case 1:
        fat_badge = `badge badge-info` // Faturado
        fat_label = `Sim` // Pendente
        break
    }
    return (<span className={fat_badge}>{fat_label}</span>)
  }

  renderPmtStatus = (risk) => {
    let fat_badge
    let fat_label
    switch (risk) {
      case 0:
        fat_badge = `badge badge-info` // Sim
        fat_label = `Sim`
        break
      default:
        fat_badge = `badge badge-warning` // Não
        fat_label = `Não`
        break
    }
    return (<span className={fat_badge}>{fat_label}</span>)
  }

  normalizeProdRisco = (v) => {
    if (v == null || v === '') return null
    const n = Number(v)
    if (!Number.isFinite(n) || n < 0 || n > 6) return null
    return n
  }

  openProductEditModal = (product) => {
    if (!product) return
    this.setState({
      addProductData: {
        ...product,
        prod_risco: this.normalizeProdRisco(product.prod_risco),
        prod_riscoDet: product.prod_riscoDet != null ? String(product.prod_riscoDet) : '',
        prod_dtLimAprovOriginal: product.prod_dtLimAprov || null,
        prod_dtContratoOriginal: product.prod_dtContrato || null,
      },
      addProductModalIsOpen: true,
    })
  }

  confirmarSolicitacaoDataLimite = async () => {
    const sol = this.state.solicitacaoDataLimite
    if (!sol || sol.saving) return
    this.setState({ solicitacaoDataLimite: { ...sol, saving: true } })
    try {
      await criarSolicitacaoDataLimite({
        prod: sol.prod,
        projId: this.props.proj_id,
        novaData: sol.novaData,
        dataAnterior: sol.dataAnterior,
        motivo: sol.motivo,
        usuarioCria: this.props.userOikosId,
      })
      notifySuccess('Solicitação enviada. A data limite muda se for aprovada.')
      this.setState({ solicitacaoDataLimite: null })
    } catch (e) {
      notifyError(e?.message || 'Não foi possível enviar a solicitação.')
      this.setState({ solicitacaoDataLimite: { ...sol, saving: false } })
    }
  }
  renderPmtRisk = (fat) => {
    let fat_badge
    let fat_label
    switch (Number(fat)) {
      case 0:
        fat_badge = `badge badge-info`
        fat_label = `Pago`
        break
      case 1:
        fat_badge = `badge badge-success`
        fat_label = `Baixo`
        break
      case 2:
        fat_badge = `badge badge-warning`
        fat_label = `Médio`
        break
      case 3:
        fat_badge = `badge badge-danger`
        fat_label = `Alto`
        break
      case 4:
        fat_badge = `badge badge-danger`
        fat_label = `Não avaliado`
        break
      case 5:
        fat_badge = `badge badge-danger`
        fat_label = `5`
        break
      case 6:
        fat_badge = `badge badge-danger`
        fat_label = `6`
        break
      default:
        fat_badge = `badge badge-secondary`
        fat_label = fat == null || fat === '' ? '—' : String(fat)
        break
    }
    return (<span className={fat_badge}>{fat_label}</span>)
  }

  credentialsOikos = async() => {
    const formData = new FormData()
    console.log('buscando as credenciais do oikos')
    try {
      // início da requisição
      formData.append('acao', 'get_credentials') // objeto enviado com a requisição indicando a rota
      formData.append('user_email', this.props.auth.user.mail)
      const res = await api_powerapps.post('/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      }) // requisição propriamente dita
      console.log('login:', res.data) // debug
      this.setState({ oikos_usuario: res.data.usuario_login, oikos_senha: res.data.usuario_senha })
    } catch (err) {
      console.log('Não foi possível logar no Oikos.', err)
    }
  }

  handleCertificate = async (url) => {
    try {
      const zipBlob = await this.getZip(url);
      await this.postZip(zipBlob);
      console.log('ZIP sent successfully');
    } catch (err) {
      console.error('Error sending ZIP:', err);
    }
  }

  getZip = async (url) => {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Failed to get zip.`);
    return await response.blob();
  };

  postZip = async (zipBlob) => {
    await fetch('https://proxy-service-236688625650.southamerica-east1.run.app', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/zip', // or omit if server infers type
    },
    body: {
      file: zipBlob
    },
  });
  };

  handleRowExpand = async (row) => {
    const productId = row.original.prod_id;
    const rowKey = String(productId);
    try {
      const res = await oikosGet({
          action: "get",
          table: "prod",
          data: {
            prod_id: productId,
            prod_ativo: 1,
          },
          fields: {
            "(SELECT pf_emailProf FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 ORDER BY projEquipe_dtCria DESC LIMIT 1))":
              "prod_responsavel_email",
            "(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 ORDER BY projEquipe_dtCria DESC LIMIT 1))":
              "prod_responsavelNome",
            ...PROD_COORDENADOR_PF_FIELDS,
            "(SELECT prodStatusTp_nome FROM prodStatusTp WHERE prodStatusTp.prodStatusTp_id = prod.prodStatusTp_id)":
              "prodStatusTp_nome",
            "(SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)":
              "prodStatusActual_id",
            "(SELECT psa.prodStatusAlt_obs FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)":
              "prodStatusAlt_obs",
            "(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)":
              "prodStatusAlt_data",
            "(SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1 OFFSET 1)":
              "prodStatusPenultimo_id",
            "(SELECT rec_aut FROM rec WHERE rec.rec_id = prod.rec_id AND rec.rec_ativo = 1 LIMIT 1)": "rec_aut",
            "(SELECT COUNT(*) FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_ativo = 1)":
              "hasStatus6",
            "(SELECT COUNT(*) FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusTp_id = 5 AND psa.prodStatusAlt_ativo = 1)":
              "hasStatus5",
          },
      });

      const payload = Array.isArray(res?.data) && res.data[0] ? res.data : null
      if (!payload) {
        this._expandFetches.delete(rowKey)
        return
      }
      this.setState((prevState) => ({
        productDetails: {
          ...prevState.productDetails,
          [rowKey]: payload,
        },
      }));
    } catch (error) {
      console.error("Failed to fetch product details:", error);
      this._expandFetches.delete(rowKey)
    }
  };

  handleEventMouseEnter = (e) => {
    clearTimeout(tooltipTimeout);

    const { clientX, clientY } = e.jsEvent;
    let tooltip = document.getElementById("fc-hover-tooltip");

    if (!tooltip) {
      tooltip = document.createElement("div");
      tooltip.className = "fc-hover-tooltip-global";
      tooltip.setAttribute("id", "fc-hover-tooltip");
      tooltip.addEventListener('mouseleave', () => {
        tooltipTimeout = setTimeout(() => tooltip.remove(), 300);
      });
      tooltip.addEventListener('mouseenter', () => {
        clearTimeout(tooltipTimeout);
      });
      document.body.appendChild(tooltip);
    }

    tooltip.innerHTML = `
      <div>
        <strong style="display:block; margin-bottom: 3px;">${e.event.title}</strong><br/>
        <span style="display:block; margin-bottom: 3px;">Projeto: ${e.event.extendedProps.proj_nome}</span><br/>
        Responsável: ${e.event.extendedProps.prod_responsavelNome ?? e.event.extendedProps.prod_responsavelNomeAtual ?? '-'}
      </div>
    `;

    Object.assign(tooltip.style, {
      position: "fixed",
      top: `${clientY + 4}px`,
      left: `${clientX + 4}px`,
      backgroundColor: "#fff",
      border: "1px solid #ccc",
      borderRadius: "8px",
      padding: "10px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
      zIndex: "9999",
      whiteSpace: "wrap",
      pointerEvents: "auto",
      maxWidth: "200px",
    });
  };

  handleEventMouseLeave = () => {
    tooltipTimeout = setTimeout(() => {
      const tooltip = document.getElementById("fc-hover-tooltip");
      if (tooltip) tooltip.remove();
    }, 300);
  };



  render() {

    const { dataIsLoading, data, oikos_usuario, oikos_senha, pqGridViewIsOpen, addProductData, addProductModalIsOpen, productDetails  } = this.state
    const { project, getProjectIsLoading,
      getProjectProductsIsLoading, projectProducts,
      projectTeam, getProjectTeamIsLoading,
      getTeamIsLoading, aval, getAvalIsLoading, aprov, getAprovIsLoading, } = this.props.technicalDep
    //const { isManager } = this.props.auth.user

    const self = this
    const columns = [
      {
        accessorKey: 'prod_desc',
        header: 'Descrição',
        size: 100,
        maxWidth: 200,
        Cell: ({ row }) => {
          const ed = self.state.editingDate
          const isEditing = self.canEditDates() && ed && ed.prod_id === row.original.prod_id && ed.field === 'prod_desc'
          if (isEditing) {
            return (
              <Input
                type="text"
                bsSize="sm"
                value={ed.value || ''}
                onChange={(e) => self.setState({ editingDate: { ...ed, value: e.target.value } })}
                onBlur={() => self.saveDateEdit()}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') self.saveDateEdit()
                  if (e.key === 'Escape') self.cancelDateEdit()
                }}
              />
            )
          }
          return (
            <span
              style={{ cursor: self.canEditDates() ? 'pointer' : 'default' }}
              title={self.canEditDates() ? 'Duplo clique para editar' : ''}
              onDoubleClick={() => self.startDateEdit(row.original.prod_id, 'prod_desc', row.original.prod_desc || '')}
            >
              {row.original.prod_desc}
            </span>
          )
        },
      },
      {
        accessorKey: 'prodStatusActual_id',
        header: 'Status',
        accessorFn: (row) => {
          switch (row.prodStatusActual_id) {
            case 2:
              return 6

            case 3:
              return 4

            case 4:
              return 3

            case 5:
              return 2

            case 6:
              return 5

            case 7:
              return 7

            case 8:
              return 9

            case 9:
              return 1

            case 1:
              return 8

          }
        },
        Cell: ({ cell, row }) => {
          switch (row.original.prodStatusActual_id) {
            case 1:
              return <LabelStatus backgroundColor="#ffde59" status="Não iniciado"/>
            case 2:
              return <LabelStatus backgroundColor="#5ce1e6" status="Em Elaboração"/>
            case 3:
              return <LabelStatus backgroundColor="#38b6ff" status="Entregue ao EP"/>
            case 4:
              return <LabelStatus backgroundColor="#cacdce" status="Entregue à Gestão"/>
            case 5:
              return <LabelStatus backgroundColor="#5271ff" status="A entregar p/ Cliente"/>
            case 6:
              return <LabelStatus backgroundColor="#7ed957" status="Entregue ao Cliente"/>
            case 7:
              return <LabelStatus backgroundColor="#c1ce02" status="Aprovado pelo Cliente"/>
            case 8:
              return <LabelStatus backgroundColor="#339933" status="Faturamento Autorizado"/>
            case 9:
              return <LabelStatus backgroundColor="#ff5757" status="Em correção"/>
          }
        },
        size: 50,
        filterSelectOptions: [
          'Não iniciado',
          'Em Elaboração',
          'Entregue ao EP',
          'Entregue à Gestão',
          'A entregar p/ Cliente',
          'Entregue ao Cliente',
          'Aprovado pelo Cliente',
          'Faturamento Autorizado',
          'Em correção',
        ],
        filterFn: 'statusFilterFn',
        filterVariant: 'multi-select'
      },
      {
        accessorKey: 'prodFatFlag_id',
        header: 'Tem faturamento',
        size: 90,
        Cell: ({ row }) => {
          const flagOn = self.isProdFatFlagOn(row.original)
          const canEdit = self.canEditSensitiveDates()
          const edFlag = self.state.editingFatFlag
          const isEditing =
            canEdit &&
            edFlag &&
            Number(edFlag.prod_id) === Number(row.original.prod_id)

          if (isEditing) {
            const ed = edFlag
            const options = self.prodFatFlagOptions()
            const selected = options.find((o) => o.prodFatFlag_id === Number(ed.selected)) || options[0]
            return (
              <Autocomplete
                size="small"
                autoHighlight
                openOnFocus
                options={options}
                getOptionLabel={(o) => (o && o.prodFatFlag_nome) || ''}
                isOptionEqualToValue={(a, b) => Number(a?.prodFatFlag_id) === Number(b?.prodFatFlag_id)}
                value={selected}
                onChange={(e, v) => {
                  self.setState({
                    editingFatFlag: { ...ed, selected: v ? Number(v.prodFatFlag_id) : 0 },
                  })
                }}
                sx={{ minWidth: 110, maxWidth: 160 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    autoFocus
                    onBlur={() => {
                      setTimeout(() => self.commitFatFlagEdit(), 0)
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault()
                        self.commitFatFlagEdit()
                      }
                      if (e.key === 'Escape') {
                        e.preventDefault()
                        e.stopPropagation()
                        self.cancelFatFlagEdit()
                      }
                    }}
                  />
                )}
              />
            )
          }

          return (
            <span
              style={{ cursor: canEdit ? 'pointer' : 'default', display: 'inline-block', minWidth: 48 }}
              title={canEdit ? 'Duplo clique para editar (Enter confirma, Esc cancela)' : ''}
              onDoubleClick={() => self.startFatFlagEdit(row.original.prod_id, row.original.prodFatFlag_id)}
            >
              {self.renderPmtFat(flagOn ? 1 : 0)}
            </span>
          )
        },
      },
      {
        accessorKey: 'rec_id',
        header: 'Evento de pagamento',
        size: 200,
        sortingFn: 'alphanumeric',
        Cell: ({ row }) => {
          const rid = row.original.rec_id
          const label = row.original.rec_ep_asso || ''
          const orcId = self.props.orcRubr_id
          let recList = self.state.recList || []
          if (rid != null && rid !== '' && !recList.some((r) => String(r.rec_id) === String(rid))) {
            recList = [...recList, { rec_id: rid, rec_ep: label || '—' }]
          }
          const openRecs = self.recEmAbertoList()
          const ids = prodRecIds(row.original)
          const hasCurrent = ids.length > 0
          const hasChoice = openRecs.length > 0 || hasCurrent
          const canAssoc = self.canEditSensitiveDates() && orcId
          const edRec = self.state.editingRec
          const isEditingRec =
            canAssoc &&
            hasChoice &&
            edRec &&
            edRec.prod_id === row.original.prod_id

          const flagOn = self.isProdFatFlagOn(row.original)
          const missingRequired = flagOn && ids.length === 0
          const labelOf = (id) => {
            const rec = recList.find((r) => Number(r.rec_id) === Number(id))
            const ep = rec && rec.rec_ep != null && String(rec.rec_ep).trim() !== ''
              ? String(rec.rec_ep)
              : (Number(id) === Number(rid) ? label : '')
            return ep ? `${id} – ${ep}` : String(id)
          }
          const displayText = ids.length
            ? ids.map(labelOf).join(', ')
            : missingRequired
              ? 'Obrigatório'
              : '—'

          const recOptionLabel = (o) => {
            if (!o || o.__none) return '— Nenhum —'
            const ep = o.rec_ep != null ? String(o.rec_ep) : ''
            return ep ? `${o.rec_id} – ${ep}` : String(o.rec_id)
          }

          if (isEditingRec) {
            const ed = edRec
            return (
              <Autocomplete
                size="small"
                autoHighlight
                openOnFocus
                options={ed.options}
                getOptionLabel={recOptionLabel}
                isOptionEqualToValue={(a, b) => {
                  if (!a && !b) return true
                  if (!a || !b) return false
                  if (a && a.__none && b && b.__none) return true
                  if ((a && a.__none) || (b && b.__none)) return false
                  return String(a.rec_id) === String(b.rec_id)
                }}
                multiple
                disableCloseOnSelect
                value={Array.isArray(ed.selected) ? ed.selected : []}
                onChange={(e, v) => {
                  self.setState({
                    editingRec: { ...ed, selected: v },
                  })
                }}
                filterOptions={(opts, params) => {
                  const q = (params.inputValue || '').trim().toLowerCase()
                  if (!q) return opts
                  return opts.filter((o) => recOptionLabel(o).toLowerCase().includes(q))
                }}
                sx={{ minWidth: 200, maxWidth: 320 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    autoFocus
                    placeholder={flagOn ? 'Obrigatório…' : 'Filtrar…'}
                    onBlur={() => {
                      // Deixa o onChange do Autocomplete aplicar antes de gravar (clique na lista)
                      setTimeout(() => self.commitRecEdit(), 0)
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault()
                        self.commitRecEdit()
                      }
                      if (e.key === 'Escape') {
                        e.preventDefault()
                        e.stopPropagation()
                        self.cancelRecEdit()
                      }
                    }}
                  />
                )}
              />
            )
          }

          if (canAssoc && !hasChoice) {
            return (
              <span
                style={{ color: '#999' }}
                title={recList.length === 0
                  ? 'Não há eventos de pagamento nesta rubrica do orçamento.'
                  : 'Não há eventos de pagamento em aberto nesta rubrica.'}
              >
                {displayText}
              </span>
            )
          }

          return (
            <span
              style={{
                cursor: canAssoc && hasChoice ? 'pointer' : 'default',
                display: 'inline-block',
                minWidth: 120,
                color: missingRequired ? '#c0392b' : (rid != null && rid !== '' ? 'inherit' : '#999'),
              }}
              title={
                missingRequired
                  ? self.fatFlagRequiredRecMsg
                  : canAssoc && hasChoice
                    ? 'Duplo clique para editar (Enter confirma, Esc cancela)'
                    : !orcId
                      ? 'Projeto sem rubrica de orçamento (orcRubr_id).'
                      : openRecs.length === 0
                        ? 'Não há eventos de pagamento em aberto nesta rubrica.'
                        : ''
              }
              onDoubleClick={() =>
                self.startRecEdit(row.original.prod_id, rid, label)
              }
            >
              {displayText}
            </span>
          )
        },
      },
      {
        id: 'rec_prazoPgto',
        header: 'Prazo de pagamento',
        size: 180,
        sortingFn: 'alphanumeric',
        accessorFn: (row) => self.getRecPgtoDisplay(row) || '',
        Cell: ({ row }) => {
          const text = self.getRecPgtoDisplay(row.original)
          if (!text) {
            return (
              <span style={{ color: '#999' }} title={row.original.rec_id ? 'EP sem prazo/regra cadastrados' : ''}>
                —
              </span>
            )
          }
          return <span title={text}>{text}</span>
        },
      },
      /*
      {
        accessorKey: 'prod_vlr',
        header: 'Valor',
        accessorFn: (row) => row.prod_vlr,
        size: 50,
        sortingFn: 'alphanumeric',
        Cell: ({ cell, row }) => {
          if (row.original.prod_vlr) return currencyFormatter.format(cell.getValue())}
      },
      */
      {
        accessorKey: 'prod_dtContrato',
        header: 'Contratual',
        accessorFn: (row) => {
          if (row.prod_dtContrato) {
            return moment(row.prod_dtContrato, 'YYYY-MM-DD').toDate();
          } else {
            return null;
          }
        },
        size: 30,
        sortingFn: 'datetime',
        Cell: ({ cell, row }) => {
          const ymd = row.original.prod_dtContrato || ''
          const ed = self.state.editingDate
          const isEditing = self.canEditDates() && ed && ed.prod_id === row.original.prod_id && ed.field === 'prod_dtContrato'
          if (isEditing) {
            return (
              <Input
                type="date"
                bsSize="sm"
                value={ed.value || ''}
                onChange={(e) => self.setState({ editingDate: { ...ed, value: e.target.value } })}
                onBlur={() => self.saveDateEdit()}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') self.saveDateEdit()
                  if (e.key === 'Escape') self.cancelDateEdit()
                }}
              />
            )
          }
          const label = ymd ? moment(ymd).format('DD/MM/YYYY') : '—'
          return (
            <span
              style={{
                cursor: self.canEditDates() ? 'pointer' : 'default',
                display: 'inline-block',
                minWidth: 70,
                color: ymd ? 'inherit' : '#999',
              }}
              title={self.canEditDates() ? 'Duplo clique para editar' : ''}
              onDoubleClick={() => self.startDateEdit(row.original.prod_id, 'prod_dtContrato', ymd)}
            >
              {label}
            </span>
          )
        }, // Format Date for display
      },
      {
        accessorKey: 'prod_dtInterna',
        header: 'Interna',
        accessorFn: (row) => {
          if (row.prod_dtInterna) {
            return moment(row.prod_dtInterna, 'YYYY-MM-DD').toDate();
          } else {
            return null;
          }
        },
        size: 30,
        sortingFn: 'datetime',
        Cell: ({ cell, row }) => {
          const ymd = row.original.prod_dtInterna || ''
          const ed = self.state.editingDate
          const isEditing = self.canEditDates() && ed && ed.prod_id === row.original.prod_id && ed.field === 'prod_dtInterna'
          if (isEditing) {
            return (
              <Input
                type="date"
                bsSize="sm"
                value={ed.value || ''}
                onChange={(e) => self.setState({ editingDate: { ...ed, value: e.target.value } })}
                onBlur={() => self.saveDateEdit()}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') self.saveDateEdit()
                  if (e.key === 'Escape') self.cancelDateEdit()
                }}
              />
            )
          }
          const label = ymd ? moment(ymd).format('DD/MM/YYYY') : '—'
          return (
            <span
              style={{
                cursor: self.canEditDates() ? 'pointer' : 'default',
                display: 'inline-block',
                minWidth: 70,
                color: ymd ? 'inherit' : '#999',
              }}
              title={self.canEditDates() ? 'Duplo clique para editar' : ''}
              onDoubleClick={() => self.startDateEdit(row.original.prod_id, 'prod_dtInterna', ymd)}
            >
              {label}
            </span>
          )
        }, // Format Date for display
      },
      {
        accessorKey: 'prodEntregueAoClienteData',
        header: 'Entrega',
        accessorFn: (row) => {
          if (row.prodEntregueAoClienteData) {
            return moment(row.prodEntregueAoClienteData, 'YYYY-MM-DD').toDate();
          } else {
            return null;
          }
        },
        size: 30,
        sortingFn: 'datetime',
        Cell: ({ cell, row }) => {
          const ymd = row.original.prodEntregueAoClienteData || ''
          const label = ymd ? moment(ymd).format('DD/MM/YYYY') : '—'
          return (
            <span
              style={{
                display: 'inline-block',
                minWidth: 70,
                color: ymd ? 'inherit' : '#999',
              }}
            >
              {label}
            </span>
          )
        },
      },
      {
        accessorKey: 'prodAprovacaoData',
        header: 'Aprovação Produto',
        accessorFn: (row) => {
          if (row.prodAprovacaoData) {
            return moment(row.prodAprovacaoData, 'YYYY-MM-DD').toDate();
          } else {
            return null;
          }
        },
        size: 30,
        sortingFn: 'datetime',
        Cell: ({ cell, row }) => {
          const ymd = row.original.prodAprovacaoData || ''
          const ed = self.state.editingDate
          const isEditing = self.canEditSensitiveDates() && ed && ed.prod_id === row.original.prod_id && ed.field === 'prodAprovacaoData'
          if (isEditing) {
            return (
              <Input
                type="date"
                bsSize="sm"
                value={ed.value || ''}
                onChange={(e) => self.setState({ editingDate: { ...ed, value: e.target.value } })}
                onBlur={() => self.saveDateEdit()}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') self.saveDateEdit()
                  if (e.key === 'Escape') self.cancelDateEdit()
                }}
              />
            )
          }
          const label = ymd ? moment(ymd).format('DD/MM/YYYY') : '—'
          return (
            <span
              style={{
                cursor: self.canEditSensitiveDates() ? 'pointer' : 'default',
                display: 'inline-block',
                minWidth: 70,
                color: ymd ? 'inherit' : '#999',
              }}
              title={self.canEditSensitiveDates() ? 'Duplo clique para editar (com confirmação)' : ''}
              onDoubleClick={() => self.startDateEdit(row.original.prod_id, 'prod_dtAprov', ymd)}
            >
              {label}
            </span>
          )
        }, // Format Date for display
      },
      {
        accessorKey: 'prod_dtAutFat',
        header: 'Autorização faturamento',
        accessorFn: (row) => {
          if (row.prod_dtAutFat) {
            return moment(row.prod_dtAutFat, 'YYYY-MM-DD').toDate();
          } else {
            return null;
          }
        },
        size: 30,
        sortingFn: 'datetime',
        Cell: ({ cell, row }) => {
          const ymd = row.original.prod_dtAutFat || ''
          const ed = self.state.editingDate
          const isEditing = self.canEditSensitiveDates() && ed && ed.prod_id === row.original.prod_id && ed.field === 'prod_dtAutFat'
          if (isEditing) {
            return (
              <Input
                type="date"
                bsSize="sm"
                value={ed.value || ''}
                onChange={(e) => self.setState({ editingDate: { ...ed, value: e.target.value } })}
                onBlur={() => self.saveDateEdit()}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') self.saveDateEdit()
                  if (e.key === 'Escape') self.cancelDateEdit()
                }}
              />
            )
          }
          const label = ymd ? moment(ymd).format('DD/MM/YYYY') : '—'
          return (
            <span
              style={{
                cursor: self.canEditSensitiveDates() ? 'pointer' : 'default',
                display: 'inline-block',
                minWidth: 70,
                color: ymd ? 'inherit' : '#999',
              }}
              title={self.canEditSensitiveDates() ? 'Duplo clique para editar (com confirmação)' : ''}
              onDoubleClick={() => self.startDateEdit(row.original.prod_id, 'prod_dtAutFat', ymd)}
            >
              {label}
            </span>
          )
        }, // Format Date for display
      },
      {
        accessorKey: 'prod_dtLimAprov',
        header: 'Limite para faturamento',
        accessorFn: (row) => {
          if (row.prod_dtLimAprov) {
            return moment(row.prod_dtLimAprov, 'YYYY-MM-DD').toDate();
          } else {
            return null;
          }
        },
        size: 30,
        sortingFn: 'datetime',
        Cell: ({ cell, row }) => {
          const ymd = row.original.prod_dtLimAprov || ''
          const label = ymd ? moment(ymd).format('DD/MM/YYYY') : '—'
          return (
            <span
              style={{
                cursor: self.canEditDates() ? 'pointer' : 'default',
                display: 'inline-block',
                minWidth: 70,
                color: ymd ? 'inherit' : '#999',
              }}
              title={self.canEditDates() ? 'Duplo clique para pedir a nova data limite' : ''}
              onDoubleClick={() => self.startDateEdit(row.original.prod_id, 'prod_dtLimAprov', ymd)}
            >
              {label}
            </span>
          )
        }, // Format Date for display
      },
      {
        accessorKey: 'prod_risco',
        header: 'Risco',
        size: 70,
        accessorFn: (row) => {
          const n = self.normalizeProdRisco(row.prod_risco)
          return n == null ? null : n
        },
        Cell: ({ row }) => {
          const risk = self.normalizeProdRisco(row.original.prod_risco)
          const det = String(row.original.prod_riscoDet || '').trim()
          const canEdit = self.canEditSensitiveDates()
          const edRisco = self.state.editingRisco
          const isEditing =
            canEdit &&
            edRisco &&
            Number(edRisco.prod_id) === Number(row.original.prod_id)

          if (isEditing) {
            const ed = edRisco
            const options = self.prodRiscoEditOptions()
            const selected =
              ed.selected == null
                ? options.find((o) => o.__none) || options[0]
                : options.find((o) => !o.__none && Number(o.value) === Number(ed.selected)) || {
                    value: ed.selected,
                    label: String(ed.selected),
                    abrev: String(ed.selected),
                  }
            return (
              <Autocomplete
                size="small"
                autoHighlight
                openOnFocus
                options={options}
                getOptionLabel={(o) => (o && o.label) || ''}
                isOptionEqualToValue={(a, b) => {
                  if (!a && !b) return true
                  if (!a || !b) return false
                  if (a.__none && b.__none) return true
                  if (a.__none || b.__none) return false
                  return Number(a.value) === Number(b.value)
                }}
                value={selected}
                onChange={(e, v) => {
                  self.setState({
                    editingRisco: {
                      ...ed,
                      selected: v && v.__none ? null : (v ? Number(v.value) : null),
                    },
                  })
                }}
                sx={{ minWidth: 72, maxWidth: 110 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    autoFocus
                    onBlur={() => {
                      setTimeout(() => self.commitRiscoEdit(), 0)
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault()
                        self.commitRiscoEdit()
                      }
                      if (e.key === 'Escape') {
                        e.preventDefault()
                        e.stopPropagation()
                        self.cancelRiscoEdit()
                      }
                    }}
                  />
                )}
              />
            )
          }

          const riscoOpt = riscoTpOptionForId(self.prodRiscoOptions(), risk)
          const display = risk == null ? '—' : (riscoOpt?.abrev || String(risk))
          const nomeTitle = riscoOpt?.label || ''
          return (
            <span
              style={{
                cursor: canEdit ? 'pointer' : 'default',
                display: 'inline-block',
                minWidth: 28,
                color: risk == null ? '#999' : 'inherit',
                fontWeight: risk == null ? 'normal' : 600,
              }}
              title={
                det
                  || nomeTitle
                  || (canEdit ? 'Duplo clique para editar (Enter confirma, Esc cancela)' : '')
              }
              onDoubleClick={() => self.startRiscoEdit(row.original.prod_id, row.original.prod_risco)}
            >
              {display}
            </span>
          )
        },
      },
    ]


    if (dataIsLoading) {
      return (
        <Card>
          <CardBody>
            <span>Carregando...</span>
          </CardBody>
        </Card>
      )
    }

    if (data && this.state.oikos_usuario) {
      return (
          <>
          {process.env.NODE_ENV !== 'production' && (
            <div
              style={{
                position: 'fixed',
                top: 8,
                right: 8,
                zIndex: 2000,
                background: 'rgba(0,0,0,0.75)',
                color: '#fff',
                padding: '6px 10px',
                borderRadius: 6,
                fontSize: 12,
                lineHeight: 1.2,
                maxWidth: 360,
                pointerEvents: 'none',
              }}
            >
              <strong>Cargo:</strong> {String(this.props.userCargo || '(vazio)')}
            </div>
          )}
          <PqGridView
            isOpen={pqGridViewIsOpen}
            Path={`https://oikos.ecoss.is/oikos/bancodedados.prod.php?proj_id=${this.props.proj_id}&login123=${oikos_usuario}&pass123=${oikos_senha}`}
            Header={`Produtos`}
            toggle={() => {
              this.setState({
                pqGridViewIsOpen: false,
              })
              this.preloading()
            }} />

            {/* <Row className="mb-3 justify-content-between">
              <div className='d-flex justify-content-between'>
                <Button
                  className='mr-2'
                  style={{backgroundColor: this.state.isTable ? '#4e515e' : '#74788d'}}
                  onClick={() => {
                      this.setState({
                      isGrid: false,
                      isCalendar: false,
                      isDashboard: false,
                      isTable: true,
                    })
                  }}
                >
                  Tabela
                </Button>
                <Button
                  style={{backgroundColor: this.state.isCalendar ? '#4e515e' : '#74788d'}}
                  className='mr-2'
                  onClick={() => this.setState({
                    isGrid: false,
                    isDashboard: false,
                    isCalendar: true,
                    isTable: false,
                  })}
                >
                  Calendário
                </Button>
                <Button
                  className='mr-2'
                  style={{backgroundColor: this.state.isGrid ? '#4e515e' : '#74788d'}}
                  onClick={() => this.setState({
                    isGrid: true,
                    isDashboard: false,
                    isCalendar: false,
                    isTable: false,
                  })}
                >
                  Grade
                </Button>
                <Button
                  className='mr-2'
                  style={{backgroundColor: this.state.isDashboard ? '#4e515e' : '#74788d'}}
                  onClick={() => this.setState({
                    isGrid: false,
                    isDashboard: true,
                    isCalendar: false,
                    isTable: false,
                  })}
                >
                  Dashboard
                </Button>
              </div>
              {this.state.isCalendar &&
                <div className="d-flex">
                  <Col style={{ zIndex: 2, width: "20rem" }}>
                    <label className="mb-1">Filtro por data</label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isClearable={false}
                      isSearchable={false}
                      defaultValue={{
                        value: 'Data prevista',
                        label: 'Data prevista',
                      }}
                      options={[
                        {
                          value: 'Data prevista',
                          label: 'Data prevista',
                        },
                        {
                          value: 'Data contratual',
                          label: 'Data contratual',
                        },
                        {
                          value: 'Data de entrega',
                          label: 'Data de entrega',
                        },
                      ]}
                      onChange={({ value }) => this.setState({ calendarDateOption: value })}
                    />
                  </Col>
                </div>
              }
            </Row> */}

            {this.state.isCalendar && (
              <Row>
                <Col>
                  <div style={{marginTop: "32px"}}>
                    <Legenda objLegenda={{"Produto Entregue": "green", "Produto com entrega atrasada" : "red", "Produto no prazo" : "grey"}}/>
                  </div>
                  <Card>
                    <CardBody>
                      <FullCalendar
                        eventMouseEnter={this.handleEventMouseEnter}
                        eventMouseLeave={this.handleEventMouseLeave}
                        handleWindowResize
                        locale={CalendarLocale}
                        plugins={[dayGridPlugin]}
                        defaultView="dayGridMonth"
                        headerToolbar={{
                          left: 'prev,next today',
                          center: 'title',
                          right: 'dayGridMonth,dayGridWeek,dayGridDay',
                        }}
                        events={(data).map((product, index) => {
                          const currentDate = moment().format('YYYY-MM-DD');
                          return {
                            id: index,
                            title: product.prod_desc,
                            prod_id: product.prod_id,
                            prod_responsavelNome: product.prod_responsavelNome ?? product.prod_responsavelNomeAtual,
                            prod_responsavelNomeAtual: product.prod_responsavelNomeAtual,
                            proj_nome: product.proj_nome,
                            allDay: true,
                            start:
                              this.state.calendarDateOption === 'Data prevista' ? product.prod_dtInterna
                              : this.state.calendarDateOption === 'Data contratual' ? product.prod_dtContrato
                              : this.state.calendarDateOption === 'Data de entrega' ? product.prodEntregueAoClienteData
                              : null,
                            color: (new Date(product.prod_dtContrato) < new Date(currentDate) && (!product.prodEntregueAoClienteData))
                              ? 'red'
                              : (product.prodEntregueAoClienteData || product.prodAprovacaoData) ? 'green' : 'grey',
                          }
                        })}
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )}

            {this.state.isGrid && (
              <div style={{marginTop: "50px"}}>
                <GridProductsCalendar rows={data} />
              </div>
            )}

            {this.state.isDashboard && (
              <div style={{marginTop: "50px"}}>
                <DashboardProdutos produtos={(data).filter(p => p.prod_ativo === undefined || Number(p.prod_ativo) === 1)} />
              </div>
            )}

            {!dataIsLoading && this.state.isTable && data?.length >= 0 && (
              <MaterialReactTable
                columns={columns}
                data={data}
                getRowId={(originalRow) => String(originalRow.prod_id)}
                initialState={{
                  density: 'compact',
                  expanded: {}, //expand all groups by default
                  pagination: { pageIndex: 0, pageSize: 50 },
                  sorting: [{ id: 'prodStatusActual_id', desc: false }], //sort by state by default
                }}
                enableGrouping={false}
                enableGlobalFilter={true}
                enableFilters={true}
                enablePagination={(data.length > 50)}
                muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                renderTopToolbarCustomActions={() => (
                  <Box marginLeft="auto">
                    <IconButton onClick= {() => this.setState({pqGridViewIsOpen: true})}>
                      {this.canEditDates() ? <Edit /> : <></>}
                    </IconButton>
                  </Box>
                )}
                muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                muiTablePaginationProps={{
                  sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                  labelRowsPerPage: <span style={{fontSize: "12px"}}>Produtos por página</span>,
                  rowsPerPageOptions: [50, 100],
                }}
                positionPagination='top'
                muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                enableRowExpansion={true}
                enableDensityToggle={false}
                enableColumnFilters={true}
                muiTableHeadCellProps={{
                  sx: {
                    '.MuiSvgIcon-root': {fontSize: "18px"},
                    fontSize: '12px',
                    fontWeight: 'normal', // Remove bold text in the header
                    padding: '8px', // Adjust padding to reduce white space
                  },
                }}

                //clicking anywhere on the row will select it
                /*muiTableBodyRowProps={({ row }) => ({
                  onClick: () =>  {
                    const aux_row = row.original
                    this.setState(
                      {
                        modalData: {
                          ...aux_row,
                        }
                      },
                      () => {
                        console.log('modalData state = ', this.state.modalData)
                        this.toggleModal()
                      }
                    )
                  },
                  sx: { cursor: 'pointer' },
                })}*/
               filterFns={{
  statusFilterFn: (row, id, filterValue) => {
    // 1. Lida com o filtro vazio (quando o usuário limpa)
    if (filterValue.length === 0) {
      return true; // Mostra todas as linhas
    }

    // 2. Pega o valor JÁ PROCESSADO pelo seu 'accessorFn'.
    // Ex: Se row.original.prodStatusActual_id for 1,
    // seu accessorFn retorna 8. Então, rowValue será 8.
    const rowValue = row.getValue(id);

    // 3. 'filterValue' é um array de strings (ex: ['Não iniciado', 'Em correção'])
    //    porque você está usando 'multi-select'.
    //    Usamos .some() para ver se ALGUM item do filtro bate com o valor da linha.
    return filterValue.some((statusString) => {

      // 4. Converte a string do filtro (ex: 'Não iniciado') para seu número (ex: 8)
      //    usando o dicionário estático da sua classe.
      const filterNumber = this.constructor.dictStatusTextNumber[statusString];

      // 5. Compara o valor da linha (ex: 8) com o número do filtro (ex: 8)
      return rowValue === filterNumber;
    });
  },
}}


                renderDetailPanel={({ row }) => {
                  const rowKey = String(row.original.prod_id);
                  const details = productDetails[rowKey];

                  if (!details) {
                    if (!this._expandFetches.has(rowKey)) {
                      this._expandFetches.add(rowKey);
                      Promise.resolve().then(() => this.handleRowExpand(row));
                    }

                    return <div>Loading details...</div>;
                  }

                  return (
                    <Box sx={{padding: '16px'}}>
                      <Row className="align-items-center mb-2">
                        <Col xs="auto" className="d-flex align-items-center">
                          <span style={{ fontSize: 13, fontWeight: 500, marginRight: 4 }}>
                            {row.original.prod_desc || 'Produto'}
                          </span>
                          {this.canEditDates() && (
                            <IconButton
                              size="small"
                              title="Editar produto"
                              aria-label="Editar produto"
                              onClick={(e) => {
                                e.stopPropagation()
                                this.openProductEditModal({
                                  ...(details[0] || {}),
                                  ...row.original,
                                })
                              }}
                              sx={{ padding: '4px' }}
                            >
                              <Edit fontSize="small" />
                            </IconButton>
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Row className="align-items-center">
                            <Col>
                              <Row className="mt-2 align-items-center">
                                <Col>
                                  <TimelineStatusProduto
                                    produto={{ ...details[0], ...row.original }}
                                    actual={details[0].prodStatusActual_id || 0}
                                    tecResp={details[0].prod_responsavelNome}
                                    dataContratual={moment(row.original.prod_dtContrato).format('DD/MM/YYYY')}
                                    dataEntregueAoEp={moment(row.original.prodStatus3_data).format('DD/MM/YYYY')}
                                    dataEntregueAGestao={moment(row.original.prodStatus4_data).format('DD/MM/YYYY')}
                                    prod_aprovCompliance={row.original.prod_aprovCompliance}
                                    prodStatusAlt_obs={details[0].prodStatusAlt_obs}
                                    userOikosId={this.props.userOikosId}
                                    userCargo={this.props.userCargo}
                                    permId={this.props.auth?.user?.perm_id}
                                    orcRubr_id={this.props.orcRubr_id}
                                    projectProducts={this.state.data || []}
                                    onProductTimelineChanged={() => {
                                      this._expandFetches = new Set()
                                      this.setState({ productDetails: {}, loadingRows: [] }, () => {
                                        this.preloading()
                                      })
                                    }}
                                  />
                                </Col>

                              </Row>
                            </Col>

                          </Row>
                          {/*<Activities product={row.original}/>*/}
                        </Col>
                      </Row>
                    </Box>)
                  }
                }
              />
            )}

          <Modal
            centered
            isOpen={Boolean(this.state.solicitacaoDataLimite)}
            toggle={() => {
              if (this.state.solicitacaoDataLimite?.saving) return
              this.setState({ solicitacaoDataLimite: null })
            }}
          >
            <ModalHeader toggle={() => this.setState({ solicitacaoDataLimite: null })}>
              Nova data limite de faturamento
            </ModalHeader>
            <ModalBody>
              <p>
                A data não muda agora. O pedido vai para aprovação, com o projeto, o produto, o valor do evento e o motivo.
              </p>
              <FormGroup>
                <Label>Nova data</Label>
                <Input
                  type="date"
                  value={this.state.solicitacaoDataLimite?.novaData || ''}
                  onChange={(e) => this.setState({
                    solicitacaoDataLimite: {
                      ...this.state.solicitacaoDataLimite,
                      novaData: e.target.value,
                    },
                  })}
                />
              </FormGroup>
              <FormGroup>
                <Label>Motivo</Label>
                <Input
                  type="textarea"
                  rows={4}
                  value={this.state.solicitacaoDataLimite?.motivo || ''}
                  onChange={(e) => this.setState({
                    solicitacaoDataLimite: {
                      ...this.state.solicitacaoDataLimite,
                      motivo: e.target.value,
                    },
                  })}
                />
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button
                type="button"
                color="light"
                disabled={this.state.solicitacaoDataLimite?.saving}
                onClick={() => this.setState({ solicitacaoDataLimite: null })}
              >
                Cancelar
              </Button>
              <Button
                type="button"
                color="primary"
                disabled={this.state.solicitacaoDataLimite?.saving}
                onClick={() => this.confirmarSolicitacaoDataLimite()}
              >
                Enviar para aprovação
              </Button>
            </ModalFooter>
          </Modal>

          <Modal
              centered={false}
              isOpen={addProductModalIsOpen}
              toggle={() => this.setState({ addProductData: {}, addProductModalIsOpen: false })}
            >
              <ModalHeader
                toggle={() => this.setState({
                  addProductData: {},
                  addProductModalIsOpen: false,
                })}
              >
                {addProductData?.prod_id ? 'Editar produto' : 'Adicionar produto'}
              </ModalHeader>
              <ModalBody>
                <FormGroup>
                  <Label>
                    Descrição
                  </Label>
                  <Input
                    value={addProductData?.prod_desc}
                    onChange={e => this.setState({
                      addProductData: {
                        ...addProductData,
                        prod_desc: e.target.value || null,
                      },
                    })} />
                </FormGroup>

                <FormGroup>
                  <Label>
                    Formato do produto final
                  </Label>
                  <Select
                    isSearchable
                    isClearable
                    isLoading={getTeamIsLoading}
                    value={['.pdf', '.docx', '.xlsx'].filter(x => (x === addProductData.prod_formato))}
                    onChange={e => this.setState({
                      addProductData: {
                        ...addProductData,
                        prod_formato: e,
                      },
                    })}
                    placeholder="Formato"
                    options={['.pdf', '.docx', '.xlsx']}
                    getOptionValue={option => option}
                    getOptionLabel={option => option}
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Responsável</Label>
                  <Select
                    isSearchable
                    isClearable
                    isLoading={getTeamIsLoading}
                    value={projectTeam.filter(x => (x.id === addProductData.prod_responsavel))}
                    onChange={e => this.setState({
                      addProductData: {
                        ...addProductData,
                        prod_responsavel: e.id,
                      },
                    })}
                    placeholder="Responsável"
                    options={projectTeam}
                    getOptionValue={option => option.id}
                    getOptionLabel={option => option.nome}
                  />
                </FormGroup>

                <FormGroup>
                  <Label>
                    Valor
                  </Label>
                  <MaskedInput
                    unmask
                    mask="R$ num"
                    blocks={{
                      num: {
                        mask: Number,
                        scale: 2, // digits after point 0 for integers
                        signed: false, // disallow negative
                        thousandsSeparator: '.', // any single char
                        padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                        normalizeZeros: false, // appends or removes zeros at ends
                        radix: ',', // fractional delimiter
                        min: 0,
                        max: 1000000000,
                      },
                    }}
                    lazy={false}
                    value={ String(addProductData.prod_vlr) }
                    onAccept={value => this.setState({
                      addProductData: {
                        ...addProductData,
                        prod_vlr: value,
                      },
                    })}
                  />
                </FormGroup>

                <FormGroup>
                  <Label>
                    Data prevista
                  </Label>

                  <DatePicker
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={addProductData?.prod_dtInterna ? moment(addProductData.prod_dtInterna).toDate() : null}
                    onChange={date => this.setState({
                      addProductData: {
                        ...addProductData,
                        prod_dtInterna: date,
                        prod_dtInterna_Invalid: false,
                      },
                    })} />
                </FormGroup>

                <FormGroup>
                  <Label>
                    Data contratual
                  </Label>

                  <DatePicker
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={addProductData?.prod_dtContrato ? moment(addProductData.prod_dtContrato).toDate() : null}
                    onChange={date => this.setState({
                      addProductData: {
                        ...addProductData,
                        prod_dtContrato: date,
                        prod_dtContrato_Invalid: false,
                      },
                    })} />
                </FormGroup>

                <FormGroup>
                  <Label>
                    Data entrega
                  </Label>

                  <DatePicker
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={addProductData?.prod_dtEntrega ? moment(addProductData.prod_dtEntrega).toDate() : null}
                    onChange={date => this.setState({
                      addProductData: {
                        ...addProductData,
                        prod_dtEntrega: date,
                        prod_dtEntrega_Invalid: false,
                      },
                    })} />
                </FormGroup>

                <FormGroup>
                  <Label>
                    Data aprovação
                  </Label>

                  <DatePicker
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={addProductData?.prod_dtAprov ? moment(addProductData.prod_dtAprov).toDate() : null}
                    onChange={date => this.setState({
                      addProductData: {
                        ...addProductData,
                        prod_dtAprov: date,
                        prod_dtAprov_Invalid: false,
                      },
                    })} />
                </FormGroup>

                <FormGroup>
                  <Label>
                    Limite para faturamento
                  </Label>

                  <DatePicker
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={addProductData?.prod_dtLimAprov ? moment(addProductData.prod_dtLimAprov).toDate() : null}
                    onChange={date => this.setState({
                      addProductData: {
                        ...addProductData,
                        prod_dtLimAprov: date,
                        prod_dtLimAprov_Invalid: false,
                      },
                    })} />
                </FormGroup>

                <FormGroup>
                  <Label>Tem faturamento associado</Label>
                  <Select
                    isSearchable={false}
                    value={this.prodFatFlagOptions().filter((x) => (
                      Number(x.prodFatFlag_id) === Number(addProductData?.prodFatFlag_id || 0)
                    ))}
                    onChange={(e) => this.setState({
                      addProductData: {
                        ...addProductData,
                        prodFatFlag_id: e ? Number(e.prodFatFlag_id) : 0,
                      },
                    })}
                    options={this.prodFatFlagOptions()}
                    getOptionValue={(option) => option.prodFatFlag_id}
                    getOptionLabel={(option) => option.prodFatFlag_nome}
                    placeholder="Não"
                  />
                </FormGroup>

                <FormGroup>
                  <Label>
                    Evento de faturamento
                    {Number(addProductData?.prodFatFlag_id) === 1 ? ' *' : ''}
                  </Label>
                  <Select
                    isSearchable
                    isMulti
                    isClearable={Number(addProductData?.prodFatFlag_id) !== 1}
                    isDisabled={!this.props.orcRubr_id}
                    value={this.recOptionsForProduct(addProductData).filter((x) => (
                      prodRecIds(addProductData).includes(Number(x.rec_id))
                    ))}
                    onChange={(opts) => {
                      const split = splitProdRecIds((opts || []).map((o) => o.rec_id), addProductData.rec_id)
                      this.setState({
                        addProductData: {
                          ...addProductData,
                          rec_id: split.rec_id,
                          prod_recExtra: split.prod_recExtra,
                        },
                      })
                    }}
                    options={this.recOptionsForProduct(addProductData)}
                    getOptionValue={(option) => option.rec_id}
                    getOptionLabel={(option) => {
                      const ep = option.rec_ep != null ? String(option.rec_ep) : ''
                      return ep ? `${option.rec_id} – ${ep}` : String(option.rec_id)
                    }}
                    placeholder={!this.props.orcRubr_id
                      ? 'Projeto sem rubrica de orçamento'
                      : this.recEmAbertoList().length === 0
                        ? 'Nenhum evento em aberto'
                        : (Number(addProductData?.prodFatFlag_id) === 1
                          ? 'Obrigatório — selecione o evento'
                          : 'Opcional')}
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Risco</Label>
                  <Select
                    isSearchable={false}
                    isClearable
                    value={this.prodRiscoOptions().filter(
                      (x) => Number(x.value) === Number(addProductData?.prod_risco)
                    )}
                    onChange={(e) => this.setState({
                      addProductData: {
                        ...addProductData,
                        prod_risco: e == null ? null : Number(e.value),
                      },
                    })}
                    options={this.prodRiscoOptions()}
                    getOptionValue={(option) => option.value}
                    getOptionLabel={(option) => option.label}
                    placeholder="—"
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Detalhamento do risco</Label>
                  <Input
                    type="textarea"
                    rows={3}
                    value={addProductData?.prod_riscoDet || ''}
                    onChange={(e) => this.setState({
                      addProductData: {
                        ...addProductData,
                        prod_riscoDet: e.target.value,
                      },
                    })}
                    placeholder="Texto exibido ao passar o mouse sobre o risco na tabela"
                  />
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button
                  type="button"
                  onClick={() => this.setState({ addProductData: {}, addProductModalIsOpen: false })}
                  color="light"
                  className="waves-effect"
                >
                  Cancelar
                </Button>
                <Button
                  type="button"
                  color="primary"
                  className="waves-effect waves-light"
                  onClick={() => this.handleSubmitProduct()}
                  disabled={!addProductData?.prod_desc
                    || !addProductData?.prod_dtInterna
                    || (Number(addProductData?.prodFatFlag_id) === 1
                      && (addProductData?.rec_id == null || addProductData.rec_id === ''))}
                >
                  {addProductData?.prod_id ? 'Salvar' : 'Adicionar'}
                </Button>
              </ModalFooter>
          </Modal>

          </>
      )
    }

    return null
  }
}

class LabelStatus extends Component {
  render() {
    const { status, backgroundColor } = this.props
    return (
      <div style={{ backgroundColor }} className={`badge ${status}`}>
        {status}
      </div>
    )
  }
}

const mapStateToProps = state => ({ auth: state.auth, technicalDep: state.technicalDep })
const mapDispatchToProps = dispatch => bindActionCreators({
  getProjectProducts,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Prod)
